let mentorJson = require('../data/mentor.json');

document.addEventListener("DOMContentLoaded", function(event) { 
    generateMentorData();

});

window.onload = () => {
    handlePageLoaded();
};

function handlePageLoaded(){
    document.getElementsByClassName("loading-screen")[0].style.display = "none";
    document.getElementById("section-meetthementors").style.display = "block";
}

async function generateMentorData() {

    let container = document.querySelector("#mentor-cards");


    mentorJson.forEach(mentor => {

      let technicalBadgeHTML = '<span class="badge mentor-badge rounded-pill">Technical</span>';
      let businessBadgeHTML = '<span class="badge mentor-badge rounded-pill">Business</span>';

        if (mentor.business !== 1) {
          businessBadgeHTML = "";
        }
        if (mentor.technical !== 1) {
          technicalBadgeHTML = "";
        }

        container.innerHTML += `
        <div class="card mentor-card p-2" style="max-width: 500px;" >
            <div class="row g-0">
                <div class="col-md-4 m-0 d-flex justify-content-center align-items-center">
                  <img src="${mentor.image}" class="img-fluid mentor-image" alt="Photo of mentor ${mentor.name}"></div>
                  <div class="col-md-8">
                  <div class="card-body p-3 pb-2">
                      <h5 class="card-title fw-bold">${mentor.name}</h5>
                      <p class="mentor-card-text lh-sm">${mentor.bio}
                      <br><br>
                      <a href="${mentor.linkedin}"><i class="fas fa-arrow-alt-circle-right me-2"></i>Find out more on LinkedIn</a> </p>
                  </div>
                  <footer class="mt-3 pb-3 mentor-badges">
                      ${technicalBadgeHTML}
                      ${businessBadgeHTML}
                  </footer>
                </div>
            </div>
        </div>
        `
    })
}